import React from "react";

import { CardMedia as MuiCardMedia, CardMediaProps } from "@mui/material";

import { mergeSx } from "merge-sx";

const CardMedia: React.FC<CardMediaProps> = ({ sx, ...props }) => {
  return (
    <MuiCardMedia
      sx={mergeSx(sx, (theme) => ({
        backgroundSize: "contain",
        width: theme.spacing(7),
        height: theme.spacing(7),
        flexShrink: 0,
        [theme.breakpoints.up("sm")]: {
          width: theme.spacing(8),
          height: theme.spacing(8),
          marginRight: theme.spacing(3),
        },
        [theme.breakpoints.between(375, "sm")]: {
          marginRight: theme.spacing(1),
        },
      }))}
      {...props}
    />
  );
};

export { CardMedia };
